import { render, staticRenderFns } from "./TrAnalysisLossesGraph.vue?vue&type=template&id=5d5e6a2e&scoped=true"
import script from "./TrAnalysisLossesGraph.vue?vue&type=script&lang=ts"
export * from "./TrAnalysisLossesGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e6a2e",
  null
  
)

export default component.exports